import { Component, input, OnInit } from '@angular/core';

const colorNames = [
  'red',
  'gray_blue',
  'white',
  'cold_white',
  'light_gray',
  'gray',
  'gray_gray_gray',
  'green-yellow',
  'gray_yellow',
  'brown',
  'green-yellow_gray',
  'gray__green-yellow',
  'gray__blue__green-yellow',
  'green-yellow_blue_gray',
  'blue_blue',
  'blue',
  'light_blue',
  'copper-colored',
  'black',
  'yellow',
  'gentian_blue',
  'yellow-green',
  'gray',
  'gray_gray',
  'gray_gray_gray',
  'violet',
  'green',
  'light_green',
  'orange',
  'dark_gray',
  'pink',
  'agate_gray',
  'no_color'
] as const;

export type ColorName = typeof colorNames[number];

export function isColorName(value: string): value is ColorName {
  return colorNames.includes(value as ColorName);
}

@Component({
  standalone: false,
  selector: 'app-color-dot',
  templateUrl: './color-dot.component.html',
  styleUrls: ['./color-dot.component.scss'],
})
export class ColorDotComponent implements OnInit {

  public color = input<ColorName>();
  public colorCode = input<string>();
  public displayBorder = input<boolean>(true);

  public cssClass = '';
  public styleColor = '';


  ngOnInit() {
    const colorCode: string | undefined = this.colorCode();
    const color = this.color();
    if (color !== undefined) {
      this.cssClass = `articlecolor-${color}`;
    } else if (colorCode !== undefined && typeof colorCode === 'string') {
      this.styleColor = colorCode;
    } else {
      this.cssClass = 'articlecolor-white';
    }
  }
}
